var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPrivatetopupcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9838_5339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 22H16",
    stroke: "#76BC21",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 4H10",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 26C9.05228 26 9.5 25.5523 9.5 25C9.5 24.4477 9.05228 24 8.5 24C7.94772 24 7.5 24.4477 7.5 25C7.5 25.5523 7.94772 26 8.5 26Z",
    fill: "#76BC21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 6.53139V3C16.25 1.75736 15.2426 0.75 14 0.75H3C1.75736 0.75 0.75 1.75736 0.75 3V25C0.75 26.2426 1.75736 27.25 3 27.25H14C15.2426 27.25 16.25 26.2426 16.25 25V19.669",
    stroke: "#76BC21",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 19.25C20.4518 19.25 23.25 16.4518 23.25 13C23.25 9.54822 20.4518 6.75 17 6.75C13.5482 6.75 10.75 9.54822 10.75 13C10.75 16.4518 13.5482 19.25 17 19.25Z",
    stroke: "#76BC21",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 11V15M15 13H19",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9838_5339"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivatetopupcode);
export default __webpack_public_path__ + "static/media/privatetopupcode.cf4e67f8f39590b9879d3f3af4154cbc.svg";
export { ForwardRef as ReactComponent };